import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CustomIcon from '../common/CustomIcon';

class NewContentCard extends React.Component {
  static propTypes = {
    customCss: PropTypes.string,
    customMessage: PropTypes.string.isRequired,
    onClick: PropTypes.func
  };

  render() {
    let { customCss, onClick, customMessage } = this.props;

    return (
      <div onClick={onClick} data-cy="newContentCard">
        <div className={customCss}>
          <div className="content-text">
            <CustomIcon name="plus-addition-sign-circle" size={18} />
            <span>{customMessage}</span>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n
  };
}

export default connect(mapStateToProps)(NewContentCard);
